module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/form/form2/form2.component.scss
// module id = ./src/app/features/form/form2/form2.component.scss
// module chunks = main